import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bdab0d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courseDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "COURSE DETAILS", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { inject, onBeforeMount, onMounted, ref, reactive } from 'vue'
    import { useRoute, useRouter } from 'vue-router';
    import PageHeader from '@/components/PageHeader.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetailView',
  setup(__props) {

    const $axios : any = inject('axios');
    const route = useRoute();

    const paragraph = ref([]);

    onBeforeMount(() => {
      $axios.get('/courses/desc', {params:{
        id:route.params.id
      }
      }).then((res: any) => {
        paragraph.value = res.data;
      });
    });

    
    const table = [
      {
        title:'Units of competency',
        isUnit:true,
        data:[
          {
            code: 'TAEXDB511',
            name: 'Develop and implement training and assessment strategies for learners with disability',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAEXDB411',
            name: 'Plan and implement individual support plans for learners with disability',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAETAS411',
            name: 'Maintain training and assessment information',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAEPDD401',
            name: 'Work effectively in the VET sector',
            usage: 'current',
            essential: 'core'
          },
          {
            code: 'TAELLN423',
            name: 'Integrate employability skills support into training and assessment',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAELLN422',
            name: 'Use foundation skills resources, strategies and advice',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAELLN421',
            name: 'Integrate core skills support into training and assessment',
            usage: 'current',
            essential: 'elective'
          },
          {
            code: 'TAEDES412',
            name: 'Design and develop plans for vocational training',
            usage: 'current',
            essential: 'core'
          },
          {
            code: 'TAEDES411',
            name: 'Use nationally recognised training products to meet vocational training needs',
            usage: 'current',
            essential: 'core'
          },
          {
            code: 'TAEDEL416',
            name: 'Facilitate learning for young vocational learners',
            usage: 'current',
            essential: 'elective'
          }
        ]
      }
    ];

    const data = reactive(
      {
        table:table,
        paragraph:paragraph,
        rootPath:'/education',
        root:'Education',
        current:'current courses',
        currentPath:'/course',
        detail:'course detail',
        isPara:true,
        isTable:true,
        isDetail:true
      }
    );
    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})